module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Home-e0e99612c4efbeadcb79f2b494618eca.svg";